var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"panel"},[_c('p',{staticClass:"panel-heading"},[_vm._v(_vm._s(_vm.$t('app-store')))]),_c('section',{staticClass:"panel-block lower-section-flex"},_vm._l((_vm.applications),function(app){return _c('AppCard',{key:app.id,attrs:{"app":app,"installable":true}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }